/** 顶栏悬停子菜单配置 — 与页面侧栏/Tab 对齐 */

import { INTRO_SECTIONS } from './introSections'
import { partySections } from './siteData'

/** 首页「通知要闻」区仅展示会议通知 + 重要新闻 */
export const NOTICE_NEWS_BOARDS = [
  { code: 'meeting_notice', label: '会议通知' },
  { code: 'important_news', label: '重要新闻' }
]

/** 通知要闻栏目页侧栏（不含党务公开；学会动态/工作进展保留） */
export const PUBLISH_NAV_BOARDS = [
  ...NOTICE_NEWS_BOARDS,
  { code: 'society_dynamics', label: '学会动态' },
  { code: 'work_progress', label: '工作进展' }
]

export const SERVICE_NAV_TABS = [
  { label: '服务大厅', value: 'main' },
  { label: '会员服务', value: 'member' },
  { label: '专业分会', value: 'branches' },
  { label: '学术会议', value: 'conference' },
  { label: '科学传播', value: 'science' },
  { label: '科技奖励', value: 'rewards' },
  { label: '国际交流', value: 'international' }
]

/**
 * @typedef {'mega' | 'compact' | 'none'} NavMenuKind
 * @typedef {{ id: string, label: string, path?: string, hash?: string, query?: object, action?: string, panel?: string, tab?: string, board?: string, branchId?: string|number }} NavChild
 */

/**
 * 静态子菜单骨架（组织机构分会、相册分类在运行时注入）
 * @returns {Record<string, { kind: NavMenuKind, title: string, children?: NavChild[], groups?: Array<{ title: string, children: NavChild[] }> }>}
 */
export function buildNavMenuMap() {
  const introChildren = INTRO_SECTIONS.map(section => ({
    id: section.id,
    label: section.title,
    path: '/intro',
    hash: section.id
  }))
  const serviceChildren = SERVICE_NAV_TABS.map(tab => ({
    id: tab.value,
    label: tab.label,
    path: '/services',
    query: { tab: tab.value },
    action: 'services-tab',
    tab: tab.value
  }))
  const partyChildren = partySections.map(section => ({
    id: section.moduleCode || section.path,
    label: section.label,
    path: section.path
  }))

  return {
    home: { kind: 'none', title: '首页' },
    intro: {
      kind: 'mega',
      title: '学会简介',
      rows: [0, 2, 4, 6, 8, 10].map(index => ({
        id: `intro-row-${index / 2 + 1}`,
        children: introChildren.slice(index, index + 2)
      }))
    },
    structure: {
      kind: 'mega',
      title: '组织机构',
      children: [] // 运行时由 SiteHeader 注入 MAIN + 分会
    },
    services: {
      kind: 'mega',
      title: '学会服务',
      rows: [
        { id: 'services-main', level: 'primary', children: serviceChildren.slice(0, 1) },
        { id: 'services-core', children: serviceChildren.slice(1, 4) },
        { id: 'services-extended', children: serviceChildren.slice(4, 7) }
      ]
    },
    party: {
      kind: 'mega',
      title: '党建文化',
      rows: [0, 2, 4, 6, 8, 10].map(index => ({
        id: `party-row-${index / 2 + 1}`,
        children: partyChildren.slice(index, index + 2)
      }))
    },
    history: { kind: 'none', title: '学会沿革' },
    gallery: { kind: 'none', title: '历史相册' },
    'society-announcements': { kind: 'none', title: '会员公告' },
    'news-publish': {
      kind: 'mega',
      title: '通知要闻',
      children: PUBLISH_NAV_BOARDS.map(board => ({
        id: board.code,
        label: board.label,
        path: '/news-publish',
        query: { board: board.code },
        board: board.code
      }))
    },
    international: { kind: 'none', title: '国际交流' },
    regulations: { kind: 'none', title: '规章条例' },
    'public-downloads': { kind: 'none', title: '公开文件' }
  }
}
